var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rbvp-rules-editor" }, [
    !_vm.state.rbvpEnabled
      ? _c("div", { staticClass: "rbvp-namespace-disabled-banner" }, [
          _c("div", { staticClass: "rbvp-namespace-disabled-banner-title" }, [
            _vm._v("RBVP 组件当前已关闭"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rbvp-namespace-disabled-banner-text" }, [
            _vm._v(
              "\n      即使存在已注册且已接管的命名空间，RBVP 也不会生效。请先在组件设置中启用 RBVP。\n    "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-status-card rbvp-debug-card" }, [
      _c("div", { staticClass: "rbvp-status-card-label" }, [
        _vm._v("调试面板"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-status-card-value" }, [
        _vm._v(_vm._s(_vm.state.debugSnapshotSummary)),
      ]),
      _vm._v(" "),
      _vm.state.debugNamespaces.length > 0
        ? _c("div", { staticClass: "rbvp-debug-toolbar" }, [
            _c("div", { staticClass: "rbvp-field-hint" }, [
              _vm._v(
                "\n        当前共 " +
                  _vm._s(_vm.state.debugNamespaces.length) +
                  " 个命名空间调试记录\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rbvp-rule-create-actions" },
              [
                _c(
                  "VButton",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.expandAllDebugNamespaces()
                      },
                    },
                  },
                  [_vm._v("全部展开")]
                ),
                _vm._v(" "),
                _c(
                  "VButton",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.collapseAllDebugNamespaces()
                      },
                    },
                  },
                  [_vm._v("全部收起")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state.debugNamespaces.length === 0
        ? _c("div", { staticClass: "rbvp-field-hint" }, [
            _vm._v("暂无调试记录"),
          ])
        : _c(
            "div",
            { staticClass: "rbvp-debug-list" },
            _vm._l(_vm.state.debugNamespaces, function (item) {
              return _c(
                "div",
                {
                  key: item.namespace,
                  staticClass: "rbvp-debug-namespace-card",
                },
                [
                  _c("div", { staticClass: "rbvp-debug-namespace-header" }, [
                    _c("div", { staticClass: "rbvp-debug-namespace-title" }, [
                      _c("div", { staticClass: "rbvp-section-title" }, [
                        _vm._v(_vm._s(item.displayName)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "rbvp-namespace-main-name" }, [
                        _vm._v(_vm._s(item.namespace)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rbvp-debug-namespace-actions" }, [
                      _c(
                        "span",
                        {
                          staticClass: "rbvp-namespace-takeover-status",
                          class: {
                            active: item.matched,
                            disabled: !item.matched,
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                item.matched
                                  ? `第 ${item.line} 行命中`
                                  : "未命中"
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "rbvp-icon-button",
                          attrs: {
                            type: "button",
                            title: _vm.isDebugNamespaceExpanded(item.namespace)
                              ? "收起细节"
                              : "展开细节",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleDebugNamespace(item.namespace)
                            },
                          },
                        },
                        [
                          _c("VIcon", {
                            attrs: {
                              icon: _vm.isDebugNamespaceExpanded(item.namespace)
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down",
                              size: 16,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rbvp-debug-namespace-summary" }, [
                    _vm._v(_vm._s(item.summary)),
                  ]),
                  _vm._v(" "),
                  _vm.isDebugNamespaceExpanded(item.namespace)
                    ? _c(
                        "div",
                        { staticClass: "rbvp-debug-steps" },
                        _vm._l(item.steps, function (step, index) {
                          return _c(
                            "div",
                            {
                              key: `${item.namespace}-${index}`,
                              staticClass: "rbvp-debug-step",
                              class: {
                                matched: step.matched === true,
                                failed: step.matched === false,
                                "execute-failed":
                                  step.type === "execute" &&
                                  step.matched === false,
                              },
                              style: {
                                paddingLeft: `${12 + step.depth * 16}px`,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "rbvp-debug-step-marker" },
                                [_vm._v(_vm._s(_vm.getDebugStepMarker(step)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "rbvp-debug-step-text" },
                                [_vm._v(_vm._s(step.message))]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "rbvp-field-hint" }, [
                        _vm._v("已收起调试追踪细节"),
                      ]),
                ]
              )
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-guide-card" }, [
      _c("div", { staticClass: "rbvp-guide-title" }, [_vm._v("调试视图")]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-text" }, [
        _vm._v(
          "\n      这里会展示最近一次规则匹配时，对各命名空间的尝试路径，便于确认命中的是哪一行、为什么生效或为什么跳过。\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }